import { jsx as c } from "react/jsx-runtime";
import { c as p } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { r as d, a as w, b as C, c as f } from "./Stack-B2DIYo_X.js";
import { r as g } from "./responsive-zaZDXrNy.js";
const A = ({
  as: s,
  gap: e = 2,
  align: a,
  justify: l,
  wrap: o = !1,
  padding: m,
  paddingX: n,
  paddingY: t,
  className: x,
  testId: r,
  ...i
}) => /* @__PURE__ */ c(
  s || "div",
  {
    "data-testid": r,
    className: p(
      "flex",
      o && "flex-wrap",
      f(a),
      C(l),
      w(e, "gap"),
      d({ padding: m, paddingX: n, paddingY: t }),
      x
    ),
    ...i
  }
), J = ({
  as: s,
  columns: e = 1,
  gap: a = 4,
  align: l,
  justify: o,
  padding: m,
  paddingX: n,
  paddingY: t,
  className: x,
  testId: r,
  ...i
}) => /* @__PURE__ */ c(
  s || "div",
  {
    "data-testid": r,
    className: p(
      "grid",
      g(e, (u) => `grid-cols-${u}`),
      f(l),
      C(o),
      w(a, "gap"),
      d({ padding: m, paddingX: n, paddingY: t }),
      x
    ),
    ...i
  }
), N = {
  sm: "max-w-screen-sm",
  md: "max-w-screen-md",
  lg: "max-w-screen-lg",
  xl: "max-w-screen-xl",
  "2xl": "max-w-screen-2xl",
  "3xl": "max-w-3xl",
  "4xl": "max-w-4xl",
  "5xl": "max-w-5xl",
  "6xl": "max-w-6xl",
  "7xl": "max-w-7xl",
  full: "max-w-full"
}, P = ({
  as: s,
  size: e = "7xl",
  padding: a = { base: 4, md: 6 },
  paddingX: l,
  paddingY: o,
  className: m,
  testId: n,
  ...t
}) => /* @__PURE__ */ c(
  s || "div",
  {
    "data-testid": n,
    className: p(
      "mx-auto w-full",
      g(e, (r) => N[r]),
      d({ padding: a, paddingX: l, paddingY: o }),
      m
    ),
    ...t
  }
);
export {
  P as C,
  J as G,
  A as I
};
